export default __webpack_public_path__ + "static/media/icons-system-hamburger.809cf09b.svg";